import cryptocurrencyTradingContent from './content/cryptocurrency-trading.json';

const cryptocurrencyTradingMock = {
    layoutType: 2,
    data: {
        name: 'cryptocurrency-trading',
        layoutType: 2,
        areasList: [
            {
                id: 'cryptocurrency-trading-page-area',
                name: 'Content',
                componentName: 'Comp:CryptocurrencyTradingPage',
                content: JSON.stringify(cryptocurrencyTradingContent),
            },
        ],
    },
};

export default cryptocurrencyTradingMock;
